import React from "react";
import Joi from "joi-browser";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { StyledTableCell, StyledTableRow } from "../services/tableStyles";
import { toast } from "react-toastify";
import PageLoading from "./common/pageLoading";
import { Pagination, Form, Modal, Button, Spinner } from "react-bootstrap";
import { addAffiliate, getAffiliates, getAffiliatesCount } from "../services/affiliateService";
import FormComponent from "./common/formComponent";
import FloatingAddButton from "./common/floatingAddButton";
import { Link } from "react-router-dom";

class Affiliates extends FormComponent {
  state = {
    data: {
      fullName: "",
      email: "",
      phone: "",
      address: "",
      commission: "",
      accountNumber: "",
      bankName: "",
      accountName: "",
    },
    errors: {},
    searchQuery: "",
    affiliates: [],
    pageSize: 20,
    currentPage: 1,
    totalAffiliates: 0,
    showAddModal: false,
    loading: "",
    processing: false,
  };

  constructor() {
    super();
    this.state.loading = true;
  }

  schema = {
    fullName: Joi.string().required().label("Full Name"),
    email: Joi.string().email().required().label("Email"),
    phone: Joi.string().required().label("Phone Number"),
    address: Joi.string().required().label("Address"),
    commission: Joi.string().required().label("Commission"),
    accountNumber: Joi.string().required().label("Account Number"),
    bankName: Joi.string().required().label("Bank Name"),
    accountName: Joi.string().required().label("Account Name"),
  };

  doSubmit = async () => {
    this.setState({ processing: true });
    const { data: payload, affiliates: originalAffiliates } = this.state;

    try {
      const { data: newAffiliate } = await addAffiliate(payload);

      const affiliates = [...originalAffiliates];
      affiliates.unshift(newAffiliate);
      this.setState({ affiliates, showAddModal: false });
      toast.success("Affiliate Added");
    } catch (ex) {
      if (ex.response && ex.response.status >= 400 && ex.response.status < 500) {
        toast.error(ex.response.data);
      }
    }
    this.setState({ processing: false });
  };

  handleSearch = async (e) => {
    this.setState({ loading: true });
    const { currentPage, pageSize } = this.state;
    const value = e.currentTarget.value;
    this.setState({ searchQuery: value, currentPage: 1 });
    await this.populateAffiliates(currentPage, pageSize, value);
  };

  handlePageChange = async (direction) => {
    this.setState({ loading: true });
    const { currentPage, pageSize, searchQuery } = this.state;
    const newPage = direction === "next" ? currentPage + 1 : currentPage - 1;

    await this.populateAffiliates(newPage, pageSize, searchQuery);
    this.setState({ currentPage: newPage });
  };

  handleShowAddModal = () => {
    this.setState({ showAddModal: true });
  };

  handleClose = () => {
    this.setState({ showAddModal: false, showConfirmModal: false });
  };

  async populateAffiliates(currentPage, pageSize, searchQuery) {
    try {
      const { data: affiliates } = await getAffiliates(currentPage, pageSize, searchQuery); //limited result
      const { data: totalAffiliates } = await getAffiliatesCount(searchQuery);
      this.setState({ affiliates, totalAffiliates });
    } catch (ex) {
      if (ex.response && ex.response.status >= 400 && ex.response.status < 500) {
        toast.error(ex.response.data);
      }
    }
    this.setState({ loading: false });
  }

  async componentDidMount() {
    const { currentPage, pageSize, searchQuery } = this.state;
    await this.populateAffiliates(currentPage, pageSize, searchQuery);
  }

  render() {
    const { data, errors, affiliates, pageSize, currentPage, totalAdmins, searchQuery, showAddModal, loading, processing } =
      this.state;

    const pagesCount = Math.ceil(totalAdmins / pageSize);

    return (
      <React.Fragment>
        <Form>
          <Form.Group controlId="searchQuery">
            <Form.Control
              type="text"
              name="searchQuery"
              value={searchQuery}
              autoFocus
              autoComplete="off"
              onChange={this.handleSearch}
              placeholder="Search Affiliates By Name, Email or Phone Number..."
            />
          </Form.Group>
        </Form>
        <Paper elevation={3}>
          <div className="card">
            <div className="card-header main-color-bg">
              <div>
                <h5>Affiliates</h5>
              </div>
            </div>
            <div className="card-body">
              <span className="card-text">
                {loading && <PageLoading loading={loading} />}
                {!loading && affiliates.length === 0 && <span>No Affiliates to Display</span>}
                {!loading && <FloatingAddButton classes="float-right mt-2 mb-3" onClick={this.handleShowAddModal} />}
                {!loading && affiliates.length > 0 && (
                  <TableContainer component={Paper}>
                    <Table aria-label="customized table">
                      <TableHead>
                        <TableRow>
                          <StyledTableCell>Full Name</StyledTableCell>
                          <StyledTableCell>Email</StyledTableCell>
                          <StyledTableCell>Phone Number</StyledTableCell>
                          <StyledTableCell>Commission</StyledTableCell>
                          <StyledTableCell>Status</StyledTableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {affiliates.map((affiliate) => (
                          <StyledTableRow key={affiliate._id}>
                            <StyledTableCell>
                              <Link to={`/affiliates/${affiliate._id}`}>{affiliate.fullName}</Link>
                            </StyledTableCell>
                            <StyledTableCell>{affiliate.email}</StyledTableCell>
                            <StyledTableCell>{affiliate.phone}</StyledTableCell>
                            <StyledTableCell>{affiliate.commission}%</StyledTableCell>
                            <StyledTableCell>{affiliate.status}</StyledTableCell>
                          </StyledTableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                )}

                {!loading && pagesCount > 0 && (
                  <Pagination className="mt-5">
                    {pagesCount > 1 && (
                      <React.Fragment>
                        {currentPage !== 1 && (
                          <Pagination.Item onClick={() => this.handlePageChange("prev")}>Previous</Pagination.Item>
                        )}
                        <Pagination.Item>
                          Page {currentPage} of {pagesCount}
                        </Pagination.Item>
                        {currentPage !== pagesCount && (
                          <Pagination.Item onClick={() => this.handlePageChange("next")}>Next</Pagination.Item>
                        )}
                      </React.Fragment>
                    )}
                  </Pagination>
                )}
              </span>
            </div>
          </div>
        </Paper>

        <Modal show={showAddModal} onHide={this.handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Add Affiliate</Modal.Title>
          </Modal.Header>
          <Form onSubmit={this.handleSubmit}>
            <Modal.Body>
              <Form.Group controlId="fullName">
                <Form.Label>Full Name</Form.Label>
                <Form.Control
                  name="fullName"
                  onChange={this.handleChange}
                  value={data.fullName}
                  size="sm"
                  type="text"
                  autoFocus
                />
                {errors.fullName && <span className="text-danger">{errors.fullName}</span>}
              </Form.Group>

              <Form.Group controlId="email">
                <Form.Label>Email address</Form.Label>
                <Form.Control name="email" onChange={this.handleChange} value={data.email} size="sm" type="email" />
                {errors.email && <span className="text-danger">{errors.email}</span>}
              </Form.Group>

              <Form.Group controlId="phone">
                <Form.Label>Phone</Form.Label>
                <Form.Control name="phone" onChange={this.handleChange} value={data.phone} size="sm" type="tel" />
                {errors.phone && <span className="text-danger">{errors.phone}</span>}
              </Form.Group>

              <Form.Group controlId="address">
                <Form.Label>Address</Form.Label>
                <Form.Control
                  as="textarea"
                  rows="3"
                  name="address"
                  onChange={this.handleChange}
                  value={data.address}
                  size="sm"
                  type="address"
                />
                {errors.address && <span className="text-danger">{errors.address}</span>}
              </Form.Group>

              <Form.Group controlId="commission">
                <Form.Label>Commission (%)</Form.Label>
                <Form.Control
                  name="commission"
                  onChange={this.handleChange}
                  value={data.commission}
                  size="sm"
                  type="number"
                />
                {errors.commission && <span className="text-danger">{errors.commission}</span>}
              </Form.Group>

              <Form.Group controlId="accountNumber">
                <Form.Label>Account Number</Form.Label>
                <Form.Control
                  name="accountNumber"
                  onChange={this.handleChange}
                  value={data.accountNumber}
                  size="sm"
                  type="text"
                />
                {errors.accountNumber && <span className="text-danger">{errors.accountNumber}</span>}
              </Form.Group>

              <Form.Group controlId="bankName">
                <Form.Label>Bank Name</Form.Label>
                <Form.Control
                  name="bankName"
                  onChange={this.handleChange}
                  value={data.bankName}
                  size="sm"
                  type="text"
                />
                {errors.bankName && <span className="text-danger">{errors.bankName}</span>}
              </Form.Group>

              <Form.Group controlId="accountName">
                <Form.Label>Account Name</Form.Label>
                <Form.Control
                  name="accountName"
                  onChange={this.handleChange}
                  value={data.accountName}
                  size="sm"
                  type="text"
                />
                {errors.accountName && <span className="text-danger">{errors.accountName}</span>}
              </Form.Group>
            </Modal.Body>

            <Modal.Footer>
              <Button onClick={this.handleClose} variant="secondary">
                Close
              </Button>
              <Button disabled={this.validate() || processing} type="submit" variant="primary">
                {processing && (
                  <Spinner as="span" className="mr-2" animation="border" size="sm" role="status" aria-hidden="true" />
                )}
                Add
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>
      </React.Fragment>
    );
  }
}

export default Affiliates;
